import React, {useEffect, useState, useRef} from 'react';
import Login from './component/common/Login'
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from './Actions'
import { AccordionActions, Input, Snackbar, TextField } from '@material-ui/core';
import SnackMsg from './component/common/SnackMsg';
import UseEffectTest from './component/common/useEffectTest';
import { useHistory } from 'react-router-dom';
import { SideToolBar, } from './DrowerMenu'
import { 
  UserSelectDialog, ServiceNotice, SendBillingToSomeState, 
  ExcahngeTotalizeButton, WanpakuImportButton
} from './component/common/commonParts';
import * as mui from './component/common/materialUi';
import { useStyles } from './component/common/StdFormParts';
import * as sfp from './component/common/StdFormParts';
import {AccountOfMenbers, AccountRestButton, AddNewAccount} from './component/account/Account';
import Button from '@material-ui/core/Button';
import { Link, useLocation } from 'react-router-dom';
import CheckProgress from './component/common/CheckProgress';
import RegistedParams from './component/Setting/RegistedParams';
import * as comMod from './commonModule';
import * as albcm from './albCommonModule';
import curaddedit from './img/curaddedit.png';
import curaddremove from './img/curaddremove.png';
import SchUserSetting from './component/schedule/SchUserSetting';
import SchUserSettingDialog from './component/schedule/SchUserSettingDialog';
import { PermMedia, ReplyAll, } from '@material-ui/icons';
import axios from 'axios';
import FsCon from './component/import/FsCon';
import UserBilling from './component/Billing/UserBilling';
import { faBullseye } from '@fortawesome/free-solid-svg-icons';
import { setBillInfoToSch } from './component/Billing/blMakeData';
import ProseedOtherOfficeis from './component/Billing/ProseedOtherOfficeis';
import Parser from 'rss-parser';
import SchAddictionBulkUpdate from './component/schedule/SchAddictionBulkUpdate';
import CntbkUploadImg from './component/ContactBook/CntbkUploadImg';
import { 
  AddBillingDtButton, AddDairijuryouDtButton, AddReceiptDtButton 
} from './component/ContactBook/AddContactsButtons';
import SchSelectMonth from './component/schedule/SchSelectMonth';
import { lightBlue } from '@material-ui/core/colors';

const suTest0 = {
  uid: 'UID1085',
  hid: 'LE5MMsTF',
  bid: 'p0CxjWNM',
  date: '2021-11-01',
  schedule: {"D20211101":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211103":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211105":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211108":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211110":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211112":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211115":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211117":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211119":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211122":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211124":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211126":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211129":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"}},
  a: 'sendUsersSchedule',
}

const suTest1 = {
  uid: 'UID1083',
  hid: 'LE5MMsTF',
  bid: 'p0CxjWNM',
  date: '2021-11-01',
  schedule: {"D20211102":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211104":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211106":{"start":"10:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["自宅","自宅"],"offSchool":1,"service":"放課後等デイサービス"},"D20211109":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211111":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211113":{"start":"10:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["自宅","自宅"],"offSchool":1,"service":"放課後等デイサービス"},"D20211116":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211118":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211120":{"start":"10:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["自宅","自宅"],"offSchool":1,"service":"放課後等デイサービス"},"D20211123":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211125":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211127":{"start":"10:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["自宅","自宅"],"offSchool":1,"service":"放課後等デイサービス"},"D20211130":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"}},
  a: 'sendUsersSchedule',
}

const suTest2 = {
  uid: 'UID5038',
  hid: 'LE5MMsTF',
  bid: 'p0CxjWNM',
  date: '2021-11-01',
  schedule: {"D20211101":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211102":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211108":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211109":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211115":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211116":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211122":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211123":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211129":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"},"D20211130":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス"}},
  a: 'sendUsersSchedule',
}
// 梅 実績にする
const sptsTest0 = {
  hid: 'LE5MMsTF',
  bid: 'p0CxjWNM',
  date: '2021-11-01',
  partOfSch: {"UID1753":{"D20211101":{"end":"17:00","start":"13:30","service":"放課後等デイサービス","transfer":["学校","自宅"],"offSchool":0,"actualCost":{"おやつ":100},"useResult":true},"D20211103":{"end":"17:00","start":"13:30","service":"放課後等デイサービス","transfer":["学校","自宅"],"offSchool":0,"actualCost":{"おやつ":100},"useResult":true}},"UID1081":{"D20211103":{"end":"17:00","start":"13:30","service":"放課後等デイサービス","transfer":["学校","自宅"],"offSchool":0,"actualCost":{"おやつ":100},"dAddiction":{"児童指導員等加配加算（Ⅰ）":"理学療法士等"},"児童指導員等加配加算（Ⅰ）":"理学療法士等","useResult":true},"D20211106":{"end":"17:00","start":"10:30","service":"放課後等デイサービス","transfer":["自宅","自宅"],"offSchool":1,"actualCost":{"おやつ":100},"useResult":true}},"UID1085":{"D20211101":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211103":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211105":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211108":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211110":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211112":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211115":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211117":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211119":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211122":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211124":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211126":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211129":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true}},"UID1083":{"D20211102":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211104":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211106":{"start":"10:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["自宅","自宅"],"offSchool":1,"service":"放課後等デイサービス","useResult":true},"D20211109":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211111":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211113":{"start":"10:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["自宅","自宅"],"offSchool":1,"service":"放課後等デイサービス","useResult":true},"D20211116":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211118":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211120":{"start":"10:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["自宅","自宅"],"offSchool":1,"service":"放課後等デイサービス","useResult":true},"D20211123":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211125":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211127":{"start":"10:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["自宅","自宅"],"offSchool":1,"service":"放課後等デイサービス","useResult":true},"D20211130":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true}},"UID4891":{},"UID5037":{}},
  a: 'sendPartOfSchedule',
}
// 梅 実績取り消す
const sptsTest1 = {
  hid: 'LE5MMsTF',
  bid: 'p0CxjWNM',
  date: '2021-11-01',
  partOfSch: {"UID1753":{"D20211101":{"end":"17:00","start":"13:30","service":"放課後等デイサービス","transfer":["学校","自宅"],"offSchool":0,"actualCost":{"おやつ":100},"useResult":false},"D20211103":{"end":"17:00","start":"13:30","service":"放課後等デイサービス","transfer":["学校","自宅"],"offSchool":0,"actualCost":{"おやつ":100},"useResult":false}},"UID1081":{"D20211103":{"end":"17:00","start":"13:30","service":"放課後等デイサービス","transfer":["学校","自宅"],"offSchool":0,"actualCost":{"おやつ":100},"dAddiction":{"児童指導員等加配加算（Ⅰ）":"理学療法士等"},"児童指導員等加配加算（Ⅰ）":"理学療法士等","useResult":false},"D20211106":{"end":"17:00","start":"10:30","service":"放課後等デイサービス","transfer":["自宅","自宅"],"offSchool":1,"actualCost":{"おやつ":100},"useResult":false}},"UID1085":{"D20211101":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211103":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211105":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211108":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211110":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211112":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211115":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211117":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211119":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211122":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211124":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211126":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211129":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false}},"UID1083":{"D20211102":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211104":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211106":{"start":"10:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["自宅","自宅"],"offSchool":1,"service":"放課後等デイサービス","useResult":false},"D20211109":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211111":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211113":{"start":"10:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["自宅","自宅"],"offSchool":1,"service":"放課後等デイサービス","useResult":false},"D20211116":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211118":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211120":{"start":"10:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["自宅","自宅"],"offSchool":1,"service":"放課後等デイサービス","useResult":false},"D20211123":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211125":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211127":{"start":"10:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["自宅","自宅"],"offSchool":1,"service":"放課後等デイサービス","useResult":false},"D20211130":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false}},"UID4891":{},"UID5037":{}},
  a: 'sendPartOfSchedule',
}

// 鮭実績
const sptsTest2 = {
  hid: 'LE5MMsTF',
  bid: 'p0CxjWNM',
  date: '2021-11-01',
  partOfSch: {"UID445":{"D20211102":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211103":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211104":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211109":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211110":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211111":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211116":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211117":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211118":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211123":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211124":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211125":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211130":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true}},"UID1082":{"D20211101":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211102":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211108":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211109":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211115":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211116":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211122":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211123":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211129":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211130":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true}},"UID1084":{"D20211104":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211105":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211111":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211112":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211118":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211119":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211125":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true},"D20211126":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":true}}},
  a: 'sendPartOfSchedule',
}
// 鮭取り消す
const sptsTest3 = {
  hid: 'LE5MMsTF',
  bid: 'p0CxjWNM',
  date: '2021-11-01',
  partOfSch: {"UID445":{"D20211102":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211103":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211104":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211109":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211110":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211111":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211116":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211117":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211118":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211123":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211124":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211125":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211130":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false}},"UID1082":{"D20211101":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211102":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211108":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211109":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211115":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211116":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211122":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211123":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211129":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211130":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false}},"UID1084":{"D20211104":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211105":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211111":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211112":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211118":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211119":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211125":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false},"D20211126":{"start":"13:30","end":"17:00","actualCost":{"おやつ":100},"dAddiction":{},"transfer":["学校","自宅"],"offSchool":0,"service":"放課後等デイサービス","useResult":false}}},
  a: 'sendPartOfSchedule',
}

const repeatSendTest = (e) => {
  let repeat = parseInt(e.currentTarget.getAttribute('repeat'));
  if (!repeat)  repeat = 1;
  Array(repeat).fill(0).map(e=>{
    const a = {...suTest0};
    const b = {...suTest1};
    const c = {...suTest2};
    albcm.sendUsersSchedule(a); //
    albcm.sendUsersSchedule(b);
    albcm.sendUsersSchedule(c);
  })
}

const repSndTestJsk = (e) =>{
  let repeat = parseInt(e.currentTarget.getAttribute('repeat'));
  if (!repeat)  repeat = 1;
  Array(repeat).fill(0).map(e=>{
    albcm.sendPartOfSchedule(sptsTest0); // 梅実績
    albcm.sendPartOfSchedule(sptsTest3); // 鮭取り消し
  })
}

const repSndTestJsk1 = (e) =>{
  let repeat = parseInt(e.currentTarget.getAttribute('repeat'));
  if (!repeat)  repeat = 1;
  Array(repeat).fill(0).map(e=>{
    const a = {...sptsTest1};
    const b = {...sptsTest2};
    albcm.sendPartOfSchedule(a); // 梅取り消し
    albcm.sendPartOfSchedule(b); // 鮭実績
  })
}

const repSndTestJskX = (e) =>{
  const a = parseInt(e.currentTarget.getAttribute('a'));
  if (a === 0)
    albcm.sendPartOfSchedule(sptsTest0); // 梅実績
  if (a === 1)
    albcm.sendPartOfSchedule(sptsTest1); // 梅取り消し
  if (a === 2)
    albcm.sendPartOfSchedule(sptsTest2); // 鮭実績
  if (a === 3)
    albcm.sendPartOfSchedule(sptsTest3); // 鮭取り消し
}


const partOfSchTest = (prms) => {
  const {hid, bid, stdDate, schedule, setRes, setSnack} = prms;
  // スケジュールから任意の2つのuidを取得する
  const uids = Object.keys(schedule)
  .filter(e=>/UID[0-9]+/.test(e)).slice(0, 2);
  const partOfSch = {};
  uids.map(e=>{
    partOfSch[e] = schedule[e];
  });
  // ダミーのスケジュール
  const oneSch ={
    "end":"17:11","start":"13:22","service":"放課後等デイサービス",
    "transfer":["学校","学校"],"offSchool":0,"actualCost":{"おやつ":100}
  };
  // ダミーの日付キー
  const dKey = 'D' + stdDate.replace(/\-/g, '');
  // ダミーのスケジュール追加（または置換）
  uids.map(e=>{
    partOfSch[e][dKey] = oneSch;
  });
  const sendPrms = {hid, bid, date: stdDate, partOfSch};
  albcm.sendPartOfSchedule(sendPrms, setRes, setSnack )
}

const TestStateUpdate = (props) => {
  const {testData, setTestData} = props;
  const clickHandler = () => {
    const v = new Date().getSeconds();
    setTestData({v, update: true});
  }
  return(
    <a onClick={clickHandler}><div>click here.</div></a>
  )
}

// etc.configReports.invoice.displayDate:true/false
// etc.configReports.invoice.displayNotice:true/false
const Xxx = () =>{
  const allstate = useSelector(state=>state);
  const {com} = allstate;
  const comEtc = com.etc? com.etc: {};
  const displayDate = comMod.findDeepPath(
    comEtc, 'configReports.invoice.displayDate'
  )
  const displayNotice = comMod.findDeepPath(
    comEtc, 'configReports.invoice.displayNotice'
  )


}

const sendAllState = async (prms) => {
  const {allState, setRes, setSnack} = prms;
  // {hid, bid, date, jino, item, state, } 
  const hid = allState.com.hid;
  const bid = allState.com.bid;
  const jino = allState.com.jino;
  const date = allState.stdDate;
  const sendData = {
    schedule: allState.schedule,
    users: allState.users,
    com: allState.com,
    dateList: allState.dateList,
    scheduleTemplate: allState.scheduleTemplate,
    serviceItems: allState.serviceItems,
  };
  const sendPrms = {
    hid, bid, jino, date, item:'allState', state: JSON.stringify(sendData)
  };
  await albcm.sendSomeState(sendPrms, setRes, setSnack, '内部データを送信しました。');
}



const sendHidBid = async (prms) => {
  const {allState, setRes, setSnack} = prms;
  // {hid, bid, date, jino, item, state, } 
  const hid = allState.com.hid;
  const bid = allState.com.bid;
  const jino = allState.com.jino;
  const date = allState.stdDate;
  const sendData = {hid, bid};
  const sendPrms = {
    hid, bid, jino, date, item:'hidbid', state: JSON.stringify(sendData)
  };
  await albcm.sendSomeState(sendPrms, setRes, setSnack, '事業所IDを送信しました。');
}

const ChangePermission = ({account}) => {
  const dispatch = useDispatch();
  const init_permission = account.permission;
  const [perms, setPerms] = useState(init_permission);
  const handleClick = () => {
    dispatch(Actions.setStore({account: {...account, permission: perms}}));
  }
  return(
    <div style={{margin: '16px 0', display: 'flex'}}>
      <TextField
        label="パーミッション設定"
        value={perms}
        onChange={e => setPerms(e.target.value)}
      />
      <div style={{paddingTop: 10, marginLeft: 8}}>
        <Button
          variant='contained'
          style={{marginRight: 8, backgroundColor: init_permission===perms ?null :lightBlue[800], color: init_permission===perms ?null :'#fff'}}
          disabled={init_permission===perms}
          onClick={() => setPerms(init_permission)}
        >
          キャンセル
        </Button>
        <Button
          variant='contained'
          color="primary"
          disabled={init_permission===perms}
          onClick={handleClick}
        >
          書き込み
        </Button>
      </div>
    </div>
  )
}

const Hoge = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const pathname = useLocation().pathname;
  const users = useSelector(state=>state.users);
  const [msg, setmsg] = useState('');
  const [severity, setseverity] = useState('');
  const [snack, setSnack] = useState({msg: '', severity: ''})
  const [dialogOpen, setDialogOpen] = useState('');
  const [userList, setUserList] = useState(
    users.map(e => ({ uid: e.uid, checked: false }))
  );
  const [res, setRes] = useState({});
  const hid = useSelector(state=>state.hid);
  const bid = useSelector(state=>state.bid);
  const schedule = useSelector(state=>state.schedule);
  const stdDate = useSelector(state=>state.stdDate);
  const allState = useSelector(state=>state);
  const account = useSelector(state => state.account);
  const skey = allState.session.key;
  const mail = allState.account.mail;
  const jino = allState.com.jino;
  const permission = comMod.parsePermission(allState.account)[0][0];
  const [file, setFile] = useState(null);
  const clickHandlr = (text, svr='')=>{
    setmsg(text);
    setseverity(svr);
  }
  const dispathcHandler = (text, severity)=>{
    dispatch(Actions.setSnackMsg(text, severity));
  }
  const tx = 'this is dispatch.';
  const loc = '/schedule';
  const [destList, setDestList] = useState(['校門', '裏庭', '駅前',]);
  const [usDialogOpen, setUsDialogOpen] = useState(false);
  const [testData, setTestData] = useState('');
  const sd = new Date(2021,2,31);
  const sds = comMod.formatDate(sd, 'YYYY-MM-DD');
  const [feed, setFeed] = useState({});
  // const addEditStyle = {cursor:`url(${curaddedit})`, padding:4}
  // const addRemoveStyle = {cursor:`url(${curaddremove})`, padding:4}
  const addEditStyle = {cursor:`url(./img/curaddedit.png)`, padding:4}
  const addRemoveStyle = {cursor:`url(${curaddremove})`, padding:4}
  useEffect(()=>{
    console.log(res, 'res');
  },[res])
  const handleClick = () => {
    partOfSchTest({hid, bid, stdDate, schedule, setRes, setSnack})
  }
  const handleClickSendAll = async () => {
    const prms = {allState, setRes, setSnack};
    await sendHidBid(prms);
    await sendAllState(prms);
  }
  useEffect(()=>{
    console.log(testData, 'testData');
    return()=>{
      console.log('hoge clean up');
      dispatch(Actions.setStore({test:'test'}));
      const f = async () => {
        setTimeout(()=>{
          const nodes = document.querySelectorAll('.hogehoge');
          // console.log('node length:', nodes.length);
          // console.log('time out working');
        }, 100);
      };
      f();
      setmsg('hoge clean up');
    }
  }, [testData]);
  
  // const [feed, setFeed] = useState({});
  useEffect(()=>{
    // ismountedはメモリリーク対策
    let isMounted = true;
    const endPoint = albcm.endPoint();
    const parser = new Parser();
    const url = endPoint + '?a=extData&url=https://rbatos.com/lp/feed/'
    // feed取得
    const f = async () => {
      let t = await parser.parseURL(url);
      setFeed(t);
    }
    if (isMounted && !feed.items){
      f();
    }
    return ()=>{
      isMounted = false;
    }
  }, [])
  const FeedRender = () => {
    const a = (feed.items && feed.items.length)? feed.items: [];
    const r =  a.map((e, i)=>{
      // サイトサマリ部分
      const snippet = e['content:encodedSnippet'].replace(/\s/, '').slice(0, 120);
      // コンテンツのhtmlソース部分
      const contentText = e['content:encoded'];
      // domに変換
      const domParser = new DOMParser();
      const dom = domParser.parseFromString(contentText, "text/html");
      // 最初の画像のurlを取得
      const imgSrc = dom.querySelector('img')
      ? dom.querySelector('img').getAttribute('src'): 'https://houday.rbatos.com/img/logoMarkW800.png';
      return (
        <a href={e.link} target='_blank' key={i}>
          <div> 
            <div>{e.title}</div>
            <div>{snippet}</div>
            <div><img src={imgSrc} style={{width:200}}/></div>
          </div>
        </a>
      )
    });
    return r;
  }
  // inpt/file要素の変更イベント
  const fileChangeHndler = (e) => {
    const t = e.currentTarget.files[0];
    console.log(t);
    if (t) setFile(t);
  }
  // 追加ファイル用カウンタ
  const fileCount = useRef(0);
  // 表示用カウンタ
  const [fcDisp, setFcDisp] = useState(0);
  const uploadHnadler = (newData) => {
    if (!file){
      return false;
    };
    console.log('hoge');
    const elm = document.querySelector('#fileupload');
    let prms = new FormData();
    const fname = file.name;
    const ext = fname.split('.')[1]; // 拡張子を取得
    if (newData)  fileCount.current = 0;
    prms.append('file', file, jino + '-' + fileCount.current + '.' + ext);
    const url = 'https://houday.rbatos.com/api/up.php';
    const headers = {'content-type': 'multipart/form-data',}
    axios.post(url, prms, headers)
    .then(res=>{
      console.log('success', res);
      elm.value = "";
      setFile(null);
      fileCount.current = fileCount.current + 1
      setFcDisp(fileCount.current);
    })
    .catch(res=>{
      console.log('error', res);
    });
  }
  // const apiChHandler = (e) =>{
  //   const name = e.currentTarget.name;
  //   comMod.setCookeis('endPoint', name);
  // }
  const removeCookieHandler = () => {
    const cookeis = comMod.removeCookieAll();
    console.log(Object.keys(cookeis).length + '件のCookieを削除しました。')
  }
  const TestFlex = () => {
    const style = {
      display: 'flex', width: '80%', margin:"0 auto", flexWrap: 'wrap',
    }
    const cStyle = {width: "25%", minWidth:150, height:100, padding: 8, background: '#aaa'}
    return (
      <div style={style}>
        <div style={cStyle}></div>
        <div style={cStyle}></div>
        <div style={cStyle}></div>
        <div style={cStyle}></div>
        <div style={cStyle}></div>
        <div style={cStyle}></div>
        <div style={cStyle}></div>
      </div>
    )
  }

  const fetchAccountsByBidHandler = async () => {
    const prms = {hid, bid, mail, key: skey, permission};
    const res = await albcm.fetchAccountsByBid(prms);
    console.log(res, 'fetchAccountsByBidHandler');
  }
  comMod.setUisCookie(comMod.uisCookiePos.templateAutoSave, 2);
  return (
    <div className='AppPage proseed hogehoge' style={{paddingTop:60}}>
      <div><a onClick={()=>setDialogOpen(true)}>open daialog.</a></div>
      <div><a onClick={() => clickHandlr('this is one')}>one</a></div>
      <div><a onClick={() => clickHandlr('this is tow')}>tow</a></div>
      <div>
        <a onClick={() => clickHandlr('this is error', 'error')}>
          this is error. by local state.
        </a>
      </div>
      <div><a onClick={() => dispathcHandler(tx, 'warning')}>
        {tx + ' warning'}
      </a></div>
      <div><a onClick={() => dispathcHandler(tx, 'success')}>
        {tx + ' success'}
      </a></div>
      <div><a onClick={() => dispathcHandler(tx, 'error')}>
        {tx + ' error'}
      </a></div>
      <div><a onClick={() => dispathcHandler(tx, '')}>
        {tx + ' (normal)'}
      </a></div>
      <UseEffectTest />
      <SnackMsg msg={msg} severity={severity} setmsg={setmsg}/>
      <SnackMsg storeStateOpen={true} />
      <SnackMsg {...snack} />
      
      <div onClick={()=>history.push(loc)}>
        this is react-router histoy test.
      </div>
      {/* <div style={{padding: 8}}>change endpoint</div>
      <div style={{margin: 8}}>
        <Button
          name = 'apixfg'
          color='primary' variant='outlined' 
          onClick={(e)=>apiChHandler(e)}
        >
          apixfg
        </Button>

      </div>
      <div style={{margin: 8}}>
        <Button
          name = 'apidev'
          color='primary' variant='outlined' 
          onClick={(e)=>apiChHandler(e)}
        >
          apidev
        </Button>
        
      </div>
      <div style={{margin: 8}}>
        <Button
          name = 'api'
          color='primary' variant='outlined' 
          onClick={(e)=>apiChHandler(e)}
        >
          api
        </Button>
        
      </div> */}
      <div style={{margin: 8}}>
        <Button
          name = 'api'
          color='primary' variant='outlined' 
          onClick={()=>{
            history.push('/chep')
          }}
        >
          接続変更
        </Button>
      </div>
      <ChangePermission account={account} />    

      <SideToolBar/>
      {/* <div style={{margin:16, padding:8, background:'#eee'}}>
        <a><div style={{margin:8}} onClick={handleClick}>
          分割書き込みテスト
        </div></a>
        <a><div style={{margin:8}} onClick={repeatSendTest}>
          3人分一回送信。青葉台11月。
        </div></a>
        <a><div style={{margin:8}} repeat='5' onClick={(e)=>repeatSendTest(e)}>
          3人分5回送信。青葉台11月。
        </div></a>
        <a><div style={{margin:8}} onClick={repSndTestJsk}>
          実績変更テスト１青葉台11月 梅実 鮭未
        </div></a>
        <a><div style={{margin:8}} onClick={repSndTestJsk1}>
          実績変更テスト２青葉台11月 梅未 鮭
        </div></a>
        <a><div style={{margin:8}} repeat='5' onClick={repSndTestJsk1}>
          実績変更テスト２青葉台11月5回
        </div></a>
        <a><div style={{margin:8}} a='0' onClick={repSndTestJskX}>
          梅実績
        </div></a>
        <a><div style={{margin:8}} a='1' onClick={repSndTestJskX}>
          梅取り消し
        </div></a>
        <a><div style={{margin:8}} a='2' onClick={repSndTestJskX}>
          鮭実績
        </div></a>
        <a><div style={{margin:8}} a='3' onClick={repSndTestJskX}>
          鮭取り消し
        </div></a>
      </div> */}
      {/* <SchUserSettingDialog open={usDialogOpen} setOpen={setUsDialogOpen} /> */}
      {/* <SchUserSetting  /> */}
      {/* <TestFlex/> */}
      <TestStateUpdate testData={testData} setTestData={setTestData} />
      <div>
        <a onClick={removeCookieHandler}>クッキーの削除</a>
      </div>
      <div>
        <a onClick={fetchAccountsByBidHandler}>アカウントの取得</a>

      </div>
      {/* <FsCon /> */}
      {/* <UserBilling /> */}
      <div style={{padding:8}}>
        <ExcahngeTotalizeButton />
      </div>
      <div style={{padding:8}}>
        <WanpakuImportButton/>
      </div>
      <div style={{padding:8}}>
        <SendBillingToSomeState sendAnyTime={false} displayButton={true}/>
      </div>
      <CntbkUploadImg/>

      {/* 橋本　10/25　送信情報の追加 */}
      <div style={{margin: '16px 8px 8px 8px'}}>送信情報の追加</div>
      {/* <AddBillingDtButton /> */}
      {/* <AddDairijuryouDtButton /> */}
      {/* <AddReceiptDtButton /> */}
      {/* <SchSelectMonth /> */}
      <a href='/users/contract/'>契約情報</a>
      <Input helperText='aaaa'/>
    </div>
  )
}

export default Hoge;